// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"da090917","92":"6364559d","99":"e6f13146","215":"b432e95a","337":"e54e4424","443":"e2b76cc5","479":"09cf0caf","531":"90294481","952":"54bf2b29"}[chunkId] + ".chunk.js";
};